module.exports = __webpack_public_path__ + "img/天坛公园.aae96942.png";